import { render, staticRenderFns } from "./ViewNotes.vue?vue&type=template&id=e16b63fa"
import script from "./ViewNotes.vue?vue&type=script&lang=js"
export * from "./ViewNotes.vue?vue&type=script&lang=js"
import style0 from "./ViewNotes.vue?vue&type=style&index=0&id=e16b63fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports